// extracted by mini-css-extract-plugin
module.exports = {"container":"Error_container__3bCfz","iconContainer":"Error_iconContainer__1Z8wz"};